import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MatDialogModule } from "@angular/material/dialog";
import { DialogConfirmarComponent } from "../components/dialog-confirmar/dialog-confirmar.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { StarRatingComponent } from "../components/star-rating/star-rating.component";
/*import { MatPaginatorIntl } from "@angular/material/paginator";
import { CustomMatPaginatorIntl } from "../services/util/custom.mat-paginator-intl";*/
import { MapaComponent } from "../components/mapa/mapa.component";
@NgModule({
    declarations: [
        DialogConfirmarComponent,
        StarRatingComponent,
        MapaComponent,
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        FuseSharedModule,
        MatSnackBarModule,
    ],
    exports: [DialogConfirmarComponent, StarRatingComponent, MapaComponent],
    entryComponents: [DialogConfirmarComponent],
})
export class SharedModule {
    /*static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                {
                    provide: MatPaginatorIntl,
                    useClass: CustomMatPaginatorIntl,
                },
            ],
        };
    }*/
}
